let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dCc8o")).then(() => parcelRequire('kkwuW'));